import React from "react";
import { Form, useFormField } from "@redriver/cinnamon";
import { connect } from "react-redux";
import { getSheetRatesState } from "features/Sheets";
import LargeFormatMeterItem from "./LargeFormatMeterItem";

const ScheduleLargeFormatMeterArray = ({
  fieldName,
  meterField,
  arrayIndex,
  printerName,
  setEditModalTrigger,
  setLargeFormatEditIndex,
}) => {
  const [__, setMeterField] = useFormField(fieldName);
  return (
    <Form.Object field={fieldName} propagateUpdates="always">
      <LargeFormatMeterItem
        meterField={meterField}
        arrayIndex={arrayIndex}
        unitInfo={meterField.largeFormatMeteredServiceName}
        printerName={printerName}
        setEditModalTrigger={setEditModalTrigger}
        setLargeFormatEditIndex={setLargeFormatEditIndex}
        setMeterField={setMeterField}
        disableCpiWarningMessages={false}
      />
    </Form.Object>
  );
};

const mapStateToProps = (state) => {
  const { allowedTieredToner } = getSheetRatesState(state);
  return { allowedTieredToner };
};

export default connect(mapStateToProps)(ScheduleLargeFormatMeterArray);
